import { createContext } from 'react';

import { mockFunction } from 'Helpers';

export const ModalContext = createContext({ onClose: mockFunction, closeByBackdropClick: false });
